<template>
  <div class="search-button">
    <span>
      <el-button icon="el-icon-search" type="primary" size="small" @click="handleSearch">查询</el-button>
      <el-button icon="el-icon-refresh-left" type="primary" size="small" @click="handleReset">重置</el-button>
    </span>
    <span v-if="isExpand" class="search-button-expand" @click="handleExpand">
      <i :class="expand ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
      {{expand ? '收起搜索条件' : '展开搜索条件'}}
    </span>
    <span style="float: right;">
      <slot></slot>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    isExpand: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      expand: false
    }
  },
  methods: {
    handleSearch () {
      this.$emit('search')
    },
    handleReset () {
      this.$emit('reset')
    },
    handleExpand () {
      this.expand = !this.expand;
      this.$emit('expand', this.expand);
    }
  }
}
</script>

<style scoped>
.search-button {
  margin-left: 16px;
  margin-top: 4px;
}
.search-button-expand {
  cursor: pointer;
  margin-left: 16px;
  font-size: 14px;
  color: #999999;
}
</style>



// WEBPACK FOOTER //
// src/components/business/SearchButton.vue